import React, { lazy, Suspense } from 'react'

import { withModalContext } from 'contexts/contexts'

const AddBoardModal = lazy(() => import('components/modals/v1/add_board_modal'))
const InviteFriendPopup = lazy(() => import('components/modals/v1/invite_friend_popup'))
const SharePortfolioModal = lazy(() => import('components/views/logged_in/menu/my_profile/share/share_portfolio_modal'))
const InviteToJobPopup = lazy(() => import('components/modals/v1/invite_to_job_popup'))
const ConnectRequestSenderView = lazy(() => import('components/modals/v1/connect_request_sender_view'))
const ConnectRequestRecipientView = lazy(() => import('components/modals/v1/connect_request_recipient_view'))

/**
 * @deprecated use instead components/modals/modal
 **/
const ModalsView = ({ modalContextProps, rootProps }) => {
  const {
    show_connect_request_recipient,
    connect_request_recipient_swipecast_user_id,
    show_connect_request_sender,
    connect_request_sender_swipecast_user_id,
    on_connect_request_sender_success,
    booking_user_id,
    showShareModal,
    user_id,
    show_invite_project,
    invite_project_user,
    show_invite_friend,
    show_add_board_modal,
    add_board_swipecast_user_id,
    onCloseConnectRequestParticipiant,
    onCloseConnectRequestSender,
    onCloseShare,
    onCloseInviteToJob,
    onCloseAddBoard,
    onCloseInviteFriend,
  } = modalContextProps
  return (
    <Suspense fallback={() => null}>
      {show_connect_request_recipient === true && (
        <ConnectRequestRecipientView
          swipecast_user_id={connect_request_recipient_swipecast_user_id}
          hidePopup={onCloseConnectRequestParticipiant}
        />
      )}

      {show_connect_request_sender === true && (
        <ConnectRequestSenderView
          swipecast_user_id={connect_request_sender_swipecast_user_id}
          hidePopup={onCloseConnectRequestSender}
          onSuccess={on_connect_request_sender_success}
        />
      )}

      {showShareModal === true && <SharePortfolioModal hidePopup={onCloseShare} swipecastUserId={user_id} />}

      {show_invite_project === true && <InviteToJobPopup user={invite_project_user} hidePopup={onCloseInviteToJob} />}

      {show_invite_friend === true && <InviteFriendPopup hidePopup={onCloseInviteFriend} />}

      {show_add_board_modal === true && (
        <AddBoardModal
          hideModal={onCloseAddBoard}
          swipecastUserId={add_board_swipecast_user_id}
          rootProps={rootProps}
        />
      )}
    </Suspense>
  )
}

/**
 * @deprecated use instead components/modals/modal
 */
export default withModalContext(ModalsView)
